<template>
    <div>
        <b-row>
            <b-col md="9">
                <b-form-group label="Address:" label-for="address">
                    <b-form-input type="text" v-model="model.address"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="3">
                <b-form-group label="Address 2:" label-for="address2" >
                    <b-form-input type="text" v-model="model.address2"></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="4">
                <b-form-group label="City:" label-for="city">
                    <b-form-input type="text" v-model="model.city"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group label="State:" label-for="stateName">
                    <b-form-input type="text" v-model="model.stateName"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group label="Zip Code:" label-for="zipCode">
                    <b-form-input type="text" v-model="model.zipCode"></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="3">
                <b-form-group label="Home Phone:" label-for="homePhone">
                    <b-form-input type="text" v-model="model.homePhone"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="3">
                <b-form-group label="Work Phone:" label-for="workPhone">
                    <b-form-input type="text" v-model="model.workPhone"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group label="Email:" label-for="email">
                    <b-form-input type="email" v-model="model.email"></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    export default {
        name: 'ContactForm',
        props: ['model']
    }
</script>
<style>

</style>
